(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logo-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-logo-carousel')) {
    customElements.define(
      'brand-logo-carousel',
      class BrandLogoCarousel extends HTMLElement {
        connectedCallback() {
          if (this.dataset.dragReady === 'true') return;

          this.wrapper = this.querySelector('.brand-track-wrapper');
          this.track = this.querySelector('.brand-track');
          if (!this.wrapper || !this.track) return;

          this.dataset.dragReady = 'true';
          this.dragged = false;
          this.wrapper.addEventListener('pointerdown', this.onPointerDown.bind(this));
          this.wrapper.addEventListener('pointermove', this.onPointerMove.bind(this));
          this.wrapper.addEventListener('pointerup', this.onPointerUp.bind(this));
          this.wrapper.addEventListener('pointercancel', this.onPointerUp.bind(this));
          this.wrapper.addEventListener('click', this.onClick.bind(this), true);
        }

        onPointerDown(event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          this.animation = this.track.getAnimations()[0];
          if (!this.animation) return;

          this.pointerId = event.pointerId;
          this.startX = event.clientX;
          this.startTime = Number(this.animation.currentTime) || 0;
          this.duration = Number(this.animation.effect.getTiming().duration) || 60000;
          this.distance = this.track.scrollWidth / 2;
          this.dragged = false;
          this.animation.pause();
          this.wrapper.classList.add('is-dragging');
          this.wrapper.setPointerCapture(event.pointerId);
        }

        onPointerMove(event) {
          if (event.pointerId !== this.pointerId || !this.animation) return;

          const delta = this.startX - event.clientX;
          if (Math.abs(delta) > 5) this.dragged = true;
          if (!this.dragged || this.distance === 0) return;

          const timeDelta = (delta / this.distance) * this.duration;
          const nextTime = ((this.startTime + timeDelta) % this.duration + this.duration) % this.duration;
          this.animation.currentTime = nextTime;
          event.preventDefault();
        }

        onPointerUp(event) {
          if (event.pointerId !== this.pointerId) return;

          if (this.wrapper.hasPointerCapture(event.pointerId)) {
            this.wrapper.releasePointerCapture(event.pointerId);
          }
          this.wrapper.classList.remove('is-dragging');
          this.animation?.play();
          this.pointerId = null;
        }

        onClick(event) {
          if (!this.dragged) return;

          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
